import type { SymbolNewsSummaryQuery } from '@thinkalpha/quant-ws-client/client.js';
import type { NewsSummary } from '@thinkalpha/quant-ws-client/contracts/news.js';
import { quantWsClient } from 'src/lib/newQuant';
import { container } from 'src/StaticContainer';

const log = container.get('Logger').getSubLogger({ name: 'NewsSummariesApi' });

export async function getNewsSummaryForSymbol(symbol: string, query: SymbolNewsSummaryQuery): Promise<NewsSummary> {
    try {
        return await quantWsClient.getSymbolNewsSummary(symbol, query);
    } catch (e) {
        log.error('Failed to fetch news summary', { error: e, symbol });
        throw e;
    }
}
